import { render, staticRenderFns } from "./taskReqConf.vue?vue&type=template&id=1f1c97d0&scoped=true"
import script from "./taskReqConf.vue?vue&type=script&lang=js"
export * from "./taskReqConf.vue?vue&type=script&lang=js"
import style0 from "./taskReqConf.vue?vue&type=style&index=0&id=1f1c97d0&prod&lang=css"
import style1 from "./taskReqConf.vue?vue&type=style&index=1&id=1f1c97d0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1c97d0",
  null
  
)

export default component.exports